import { useEffect } from "react";
import { useAnalytics } from "../../../contexts/analytics/hooks";
import type { RequestOrigins, ShiftRequest } from "../../../utils/models";
import type { RequestOriginViewLevel } from "./requestOriginMeta";

/** Tracks one look at a request's origin, once per mount — its cards and panels mount only when they are opened. */
export const useTrackOriginViewed = (request: ShiftRequest, origins: RequestOrigins, level: RequestOriginViewLevel): void => {
	const { track } = useAnalytics();
	const kind = origins.openings[0].kind;
	const causeCount = origins.openings.length;
	useEffect(() => {
		track("request_origin_viewed", { department_id: request.department_id, request_id: request.id, level, kind, cause_count: causeCount });
	}, [track, request.department_id, request.id, level, kind, causeCount]);
};
